<template>
	<section class="dash-box">
		<ui-card-toggle
			v-if="data.length"
			:open="true"
			:icon="icon"
			:shadow="1"
			:maxHeight="maxHeight"
		>
			<template v-slot:title>
				{{ title }}
			</template>
			<template v-if="showFilter" v-slot:filter>
				<ui-select
					v-model="filterSelected"
					:label="filterLabel"
					:load="loadFilters"
					inline
					size="sm"
				>
					<option v-for="filter in filters" :key="filter.id" :value="filter.id">
						{{ filter.text }}
					</option>
				</ui-select>
			</template>
			<template v-slot:content>
				<component v-for="item in data" :key="item.id" :is="component" :data="item">
				</component>
			</template>
		</ui-card-toggle>
		<ui-no-content-box
			v-if="!data.length"
			:load="load"
			:icon="icon"
			:text="noItemsMsg"
			:btnText="noItemsBtnText"
			:goTo="!modal ? noItemsBtnUrl : null"
			:goToLegacy="!modal ? noItemsBtnUrlLegacy: null"
			:maxHeight="noContentHeight"
			@click="openModal(modal)"
		/>
		<ui-overlay-load v-if="reload" />
	</section>
</template>

<script>
	import uiCardToggle from '../toggle'
	import { uiSelect } from '@/components/ui/form'
	import { uiNoContentBox, uiOverlayLoad } from '@/components/ui'

	export default {
		components: { uiCardToggle, uiSelect, uiNoContentBox, uiOverlayLoad },
		props: {
			icon: {
				type: String,
				required: false,
			},
			title: {
				type: String,
				required: false,
			},
			filterLabel: {
				type: String,
				required: false,
			},
			service: {
				type: String,
				required: false,
			},
			filterName: {
				type: String,
				required: false,
				default: 'filter',
			},
			item: {
				type: String,
				required: false,
			},
			maxHeight: {
				type: Number,
				required: false,
				default: 450,
			},
			noItemsMsg: {
				type: String,
				required: false,
				default: 'Não encontramos nenhum registro',
			},
			noItemsBtnText: {
				type: String,
				required: false,
				default: 'Visualizar todos',
			},
			noItemsBtnUrl: {
				type: String,
				required: false,
				default: '',
			},
			noItemsBtnUrlLegacy: {
				type: String,
				required: false,
				default: '',
			},
			showFilter: {
				type: Boolean,
				required: false,
				default: true,
			},
			owners: {
				type: Boolean,
				required: false,
				default: false,
			},
			page: {
				type: Number,
				required: false,
				default: 1,
			},
			per_page: {
				type: Number,
				required: false,
				default: 15,
			},
			q: {
				type: String,
				required: false,
				default: '',
			},
			others: {
				type: Object,
				required: false,
			},
			filter_url: {
				type: String,
				required: false,
			},
			status: {
				required: false,
			},
			modal: {
				type: String,
				required: false
			}
		},
		computed: {
			loadComponent() {
				return () => import('@/components/ui-facilita/' + this.item)
			},
			loadService() {
				return () => import('@/services/axios/modules/' + this.service + '.js')
			},
			dataFilter() {
				return this.filterSelected
			},
			noContentHeight() {
				return this.maxHeight + 68
			},
		},
		watch: {
			dataFilter() {
				if (this.filterSelected === null) {
					this.getData()
				} else {
					this.getData(this.filterSelected)
				}
			},
		},
		data() {
			return {
				component: null,
				api: null,
				data: [],
				load: true,
				reload: false,
				loadFilters: true,
				filters: [],
				filterSelected: '',
				serviceParams: null,
			}
		},
		methods: {
			getData(filter = null) {
				this.reload = this.load ? false : true

				let url = this.serviceParams.url

				let params = {
					...this.serviceParams.params,
				}

				if (this.serviceParams.filter_url && filter) {
					url = this.serviceParams.filter_url.replace('{filter}', filter)
				} else if (filter) {
					params[this.filterName] = filter
				}
				this.api
					.getData(url, params)
					.then((response) => {
						this.load = false
						this.reload = false

						if (response.data.total) {
							this.data = response.data.data
							this.$emit('input', response.data.data)
						} else if (response.data.length) {
							this.data = response.data
							this.$emit('input', response.data)
						} else {
							this.data = []
							this.$emit('input', [])
						}

						this.counter()
					})
					.catch((error) => {
						console.log(error)
					})
			},
			openModal (data) {
				if(data) {
					this.$root.$emit('modal-open-' + data)
				}
			},
			getFilterData() {
				this.api
					.readFilters()
					.then((response) => {
						this.loadFilters = false
						if (response.data.length) {
							this.filters = response.data
						}
					})
					.catch((error) => {
						console.log(error)
					})
			},
			counter() {
				if (this.service === 'task') {
					let total = this.data.length
					this.$root.$emit('total-task', total)
				}
			},
		},
		beforeMount() {
			this.loadComponent().then(() => {
				this.component = () => this.loadComponent()
			})
		},
		mounted() {
			this.loadService().then(async (response) => {
				this.api = response.default.build()
				await this.getData()
				if (this.showFilter) this.getFilterData()
			})
		},
		created() {
			this.$on('clear-filter', () => {
				this.filterSelected = null
			})

			if (this.filter_url) {
				var filter_url = {
					filter_url: this.filter_url,
				}
			}

			if (this.owners) {
				var owners = {
					owners: this.owners,
				}
			}

			if (this.q) {
				var q = {
					q: this.q,
				}
			}

			if (this.status) {
				var status = {
					status: this.status,
				}
			}

			if (this.page) {
				var page = {
					page: this.page,
				}
			}

			if (this.per_page) {
				var per_page = {
					per_page: this.per_page,
				}
			}

			this.serviceParams = {
				url: '',
				...filter_url,
				params: {
					...owners,
					...q,
					...status,
					...page,
					...per_page,
					...this.others,
				},
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
